import { useMemo } from 'react';
import type { DrillProps } from './meta';
import { NumberDrill } from './NumberDrill';
import { makeSeqRound } from './seq';

export function SeqDrill({ level, seed, onDone }: DrillProps) {
  const questions = useMemo(() => makeSeqRound(level, seed), [level, seed]);
  return (
    <NumberDrill
      questions={questions} seed={seed} onDone={onDone} className="seq-drill"
      info={(q) => ({ terms: q.terms, answer: q.answer })}
      render={(q, revealed) => (
        <div className="seq-terms" aria-label="수열">
          {q.terms.map((t, i) => (
            <span key={i} className={`seq-term ${t === null ? 'blank' : ''}`}>{t === null ? (revealed ? q.answer : '?') : t}</span>
          ))}
        </div>
      )}
    />
  );
}
